<p>clinical-document-create-modal works!</p>
